module.exports = __webpack_public_path__ + "img/error-security-blocked-purchase.d4549e06.png";